import React from 'react';
import AuthenticatedLayout from './layout/AuthenticatedLayout';

require('../less/main.less');
require('../less/style.less');
require('../css/flags.css');

export default class App extends React.Component {
  onKeyUp(e){
    if(e.which == 91) {
      this.cmdPressed = false;      
    } 
    if (e.which == 18){
      this.altPressed = false;
    }
  }
  onKeyDown(e){ 
      var t = this;
      if(e.which == 91){
        this.cmdPressed = true;         
        setTimeout(() => {
          t.cmdPressed = false;
        }, 500);
      }
      if (e.which == 18){
        this.altPressed = true;
        setTimeout(() => {
          t.altPressed = false;
        }, 500);
      }
      if(e.which == 13 && this.cmdPressed == true){
        var cmdEnter = new Event("cmdEnter");
        window.dispatchEvent(cmdEnter);
        e.preventDefault();
        return false;
      }

      if(e.which == 78 && this.altPressed == true){
        var altNPressed = new Event("altNPressed");
        window.dispatchEvent(altNPressed);
        e.preventDefault();
        return false;
      }
 
      if(e.which == 83 && this.altPressed == true){        
        var altSPressed = new Event("altSPressed");
        window.dispatchEvent(altSPressed);
        e.preventDefault();
        return false;
      }

      if(e.which == 70 && this.altPressed == true){
        var cmdEnter = new Event("altFPressed");
        window.dispatchEvent(cmdEnter);
        e.preventDefault();
        return false;
      }

      if(e.which == 27){
        var keyEvent = new Event("escapePressed");
        window.dispatchEvent(keyEvent);
      }

      if(e.which == 13){
        var keyEvent = new Event("enterPressed");
        window.dispatchEvent(keyEvent);
      }
  }

  // when window re-focuses we don't want to have any left over cmd or alt presses
  windowBlur(){
      this.cmdPressed = false;
      this.altPressed = false; 
  }

  componentDidMount() {
      window.addEventListener('blur', this.windowBlur);
      window.addEventListener('focus', this.windowBlur);
      document.addEventListener('keyup', this.onKeyUp);
      document.addEventListener('keydown', this.onKeyDown);      
  }

  componentWillUnmount(){
    document.removeEventListener('keyup', this.onKeyUp);
    document.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('blur', this.windowBlur);    
    window.removeEventListener('focus', this.windowBlur);  
  }

  render() {
      return (
          <AuthenticatedLayout>{this.props.children}</AuthenticatedLayout>
      );
  }
}



// WEBPACK FOOTER //
// ./app/App.js